import type {
  BusinessCompleteSolutionsState,
  BusinessCompleteSolutionsActions,
} from "./types";

const INITIAL_STATE: BusinessCompleteSolutionsState = {
  loading: false,
  error: false,
  data: {
    banner: null,
    depositBanner: null,
    cashBanner: null,
    deposit: null,
    cash: null,
    insurance: null,
    investment: null,
    forex: null,
    loanBanner: null,
    loan: null,
    investmentBanner: null,
    forexBanner: null,
    insuranceBanner: null,
  },
};

export default (
  state: BusinessCompleteSolutionsState = INITIAL_STATE,
  action: BusinessCompleteSolutionsActions
): BusinessCompleteSolutionsState => {
  switch (action.type) {
    case "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_FAILED": {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
